<div *ngIf="type() && type() === 'icons'">
    <label for="iconsAndroid">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input multiple (change)="onIconsUpload($event)" type="file" id="iconsAndroid" style="display: none" accept=".png">
    </label>
</div>

<div *ngIf="type() && type() === 'appIcon'">
    <label for="appIconAndroid">
        <i class="upload-icon fa-solid fa-upload"></i>
        <input (change)="onAppIconUpload($event)" type="file" id="appIconAndroid" style="display: none" accept=".png">
    </label>
</div>